import styled from 'styled-components';

interface FormGroupProps {
  fullWidth?: boolean;
}

// export const ModalOverlay = styled.div`
//   position: fixed;
//   top: 0;
//   left: 0;
//   right: 0;
//   bottom: 0;
//   background-color: rgba(0, 0, 0, 0.5);
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   z-index: 1000;
// `;

// export const ModalContainer = styled.div`
//   background-color: white;

//   width: 400px;
//   padding: 24px;
// `;

// export const ModalContent = styled.div`
//   background-color: #F3F4F6;
//   border-radius: 4px;
//   padding: 24px;
//   border: 1px solid #dee2e6;
 
 
// `;

export const Title = styled.h2`
  margin: 0 0 24px;
  font-weight: 500;
  font-size: 20px;
  line-height: 20px;
  letter-spacing: 0.4px;
  color: #2563EB;
`;

export const FormGroup = styled.div<FormGroupProps>`
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const Label = styled.label`
  display: block;
  color: #495057;
  font-size: 0.875rem;
  margin-bottom: 8px;
`;

export const Input = styled.input`
  width: 100%;
  height: 38px;
  padding: 8px 12px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  font-size: 0.875rem;
  background-color: white;

  &::placeholder {
    color: #adb5bd;
  }

  &:disabled {
    background-color: white;
    color: #495057;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 24px;
`;

export const Button = styled.button`
  min-width: 120px;
  height: 38px;
  padding: 0 16px;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: normal;
  cursor: pointer;

  &.primary {
    background-color: #0066FF;
    color: white;
    border: none;
    transition: background-color 0.3s ease;
    

    &:hover {
      background-color: #0052cc;
    }

    &:disabled {
      background-color: #99c2ff;
      cursor: not-allowed;
    }
  }

  &.secondary {
    background-color: transparent;
    color: #0066FF;
    border: 1px solid #0066FF;

    &:hover {
      background-color: rgba(0, 102, 255, 0.1);
    }
  }
`;
